(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicePaymentDialogController', InvoicePaymentDialogController);

    InvoicePaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InvoicePayment', 'Invoice'];

    function InvoicePaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InvoicePayment, Invoice) {
        var vm = this;

        vm.invoicePayment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.invoices = Invoice.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.invoicePayment.id !== null) {
                InvoicePayment.update(vm.invoicePayment, onSaveSuccess, onSaveError);
            } else {
                InvoicePayment.save(vm.invoicePayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:invoicePaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;
        vm.datePickerOpenStatus.payDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
